import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import tr from "./locales/tr.json";
import en from "./locales/en.json";
import de from "./locales/de.json";

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // Default language: TR. We DO NOT hard-set `lng` here so the
        // LanguageDetector (localStorage) wins on subsequent visits.
        // Fresh visitors: detector finds nothing → fallbackLng="tr" applies.
        resources: {
            tr: { translation: tr },
            en: { translation: en },
            de: { translation: de },
        },
        fallbackLng: "tr",
        supportedLngs: ["tr", "en", "de"],
        interpolation: { escapeValue: false },
        detection: {
            order: ["localStorage"],
            caches: ["localStorage"],
            lookupLocalStorage: "otelpro-lang",
        },
    });

export default i18n;
